import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import * as api from "../../api/getapi";
import useApi from "../../Hooks/useApi";
import * as postapi from "../../api/postapi";
import Loader from "../Loader";
import { toast } from "react-toastify";

const OrdersConfigurationModal = ({ show, onHide, toggle }) => {
  const [loading, setLoading] = useState(false);
  const [configs, setConfigs] = useState([]);
  const [isClicked, setIsClicked] = useState(false);
  const fetchOrdersConfig = useApi(api.fetchOrdersConfigs, { hasCatchError: true });
  const updateOrderConfig = useApi(postapi.updateOrderConfigurations, { hasCatchError: true });
  const configMapping = {
    is_tb_bear_merchant_charges: {
      key: "is_tb_bear_merchant_charges",
      label: "Techbazaar is bearing Merchant charges",
      prevValue: false,
      currValue: false,
    },
  };
  const getOrdersConfig = async () => {
    try {
      setLoading(true);
      const resp = await fetchOrdersConfig.request();
      if (resp) {
        const keys = Object.keys(configMapping);
        const data = Object.entries(resp.data)
          .filter((item) => keys.includes(item[0]))
          .map(([k, v]) => ({
            ...configMapping[k],
            currValue: !!v,
            prevValue: !!v,
          }));
        setConfigs(data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      setConfigs([]);
    }
  };
  useEffect(() => {
    getOrdersConfig();
  }, [show]);
  const handleSubmit = async (e) => {
    try {
      setIsClicked(true);
      const payload = configs.reduce((obj, current) => {
        obj[current.key] = current.currValue;
        return obj;
      }, {});
      const data = await updateOrderConfig.request(payload);
      if (data) {
        setIsClicked(false);
        toast.success("Order configurations updated successfully", { position: "bottom-right", autoClose: 1500, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined });
        onHide();
        toggle();
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <Modal aria-labelledby="contained-modal-title-vcenter" centered size="lg" backdrop="static" show={show}>
        <Modal.Header className="border-0 pt-3 border-bottom">
          <div className="d-flex align-items-center gap-4">
            <h4>{"Deliver For You Orders Configurations"}</h4>
          </div>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div
              style={{
                height: "50vh",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Loader />
            </div>
          ) : configs.length === 0 ? (
            <div className="text-center">No configuration Found</div>
          ) : (
            <>
              {configs.map((item, index) => (
                <Row className="py-2 mb-2 fs-20" key={index}>
                  <Col lg={"6"}>
                    <Form.Group>
                      <Form.Check
                        type="checkbox"
                        className="fs-17"
                        label={item.label}
                        checked={item.currValue}
                        onChange={(e) => {
                          setConfigs((prev) =>
                            prev.map((value, i) => {
                              if (i === index) {
                                return {
                                  ...value,
                                  currValue: e.target.checked,
                                };
                              } else {
                                return value;
                              }
                            })
                          );
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              ))}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          {configs.some((value) => value.prevValue !== value.currValue) ? (
            <Button size="sm" style={{ fontSize: "14px" }} onClick={handleSubmit} disabled={isClicked}>
              <span>Submit</span>
            </Button>
          ) : (
            <></>
          )}
          <Button size="sm" variant="outline-secondary" style={{ fontSize: "14px" }} onClick={onHide}>
            <span>Close</span>
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default OrdersConfigurationModal;
